import { render, staticRenderFns } from "./InitiateProcess.vue?vue&type=template&id=5ff4c042&scoped=true"
import script from "./InitiateProcess.vue?vue&type=script&lang=js"
export * from "./InitiateProcess.vue?vue&type=script&lang=js"
import style0 from "./InitiateProcess.vue?vue&type=style&index=0&id=5ff4c042&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff4c042",
  null
  
)

export default component.exports